import SignalRHubConnectionState from './signalr-hub-connection-state';

export default SignalRHubConnectionState;